document.addEventListener("DOMContentLoaded", function () {
  let isGridApplied = false;
  let debounceTimer = null;

  const targetDivs = document.querySelectorAll(
    "[data-group-grid]:not([data-group-grid='after-this'])"
  );

  const sections = Array.from(targetDivs)
    .map((div) => div.closest(".shopify-section"))
    .filter(Boolean);

  const refDiv = document.querySelector("[data-group-grid='after-this']");
  const referenceSection = refDiv ? refDiv.closest(".shopify-section") : null;

  function applyGrid() {
    if (isGridApplied || document.querySelector(".custom-grid-sections"))
      return;
    if (!referenceSection || sections.length === 0) return;

    const wrapper = document.createElement("div");
    wrapper.classList.add("custom-grid-sections");

    sections.forEach((sec) => {
      if (sec && sec.parentNode) wrapper.appendChild(sec);
    });

    const container = document.getElementById("template-prod");
    if (container) {
    container.insertBefore(wrapper, referenceSection.nextSibling);
    isGridApplied = true;

    const specs = Array.from(
      wrapper.querySelectorAll('[id*="__product_specifications_"]')
    );

    if (specs.length > 0) {
      const firstSpec = specs[0];
      firstSpec.classList.add("specs");
      wrapper.insertBefore(firstSpec, wrapper.firstChild);

      const contentWrapper = document.createElement("div");
      contentWrapper.classList.add("content-custom-grid");

      Array.from(wrapper.children).forEach((el) => {
        if (el !== firstSpec) {
          contentWrapper.appendChild(el);
        }
      });

      wrapper.appendChild(contentWrapper);
    }
  }
  }

  function restoreOriginal() {
    if (!isGridApplied) return;

    const wrapper = document.querySelector(".custom-grid-sections");
    const contentWrapper = document.querySelector(".content-custom-grid")
    if (!wrapper) return;

    const container = document.getElementById("template-prod");
    const movedSections = Array.from(wrapper.children);
    const movedSectionsContent = Array.from(contentWrapper.children);

    movedSections.forEach((sec) => {
      container.insertBefore(sec, wrapper);
    });

    movedSectionsContent.forEach((sec) => {
      container.insertBefore(sec, wrapper);
    });

    wrapper.remove();
    contentWrapper.remove();
    isGridApplied = false;
  }

  function debouncedHandleChange(e) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (e.matches) {
        applyGrid();
      } else {
        restoreOriginal();
      }
    }, 150);
  }

  const mql = window.matchMedia("(min-width: 1024px)");

  if (mql.matches) {
    applyGrid();
  }

  mql.addEventListener("change", debouncedHandleChange);

  window.addEventListener("beforeunload", () => {
    clearTimeout(debounceTimer);
  });
});

